// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"ka","information":"kb"};